<template>
  <div>
    <CellGroup>
      <div style="display: flex; justify-content:space-between">
        <Cell value-class="cell-value" title="警情列表">
          <span
            slot="extra"
            v-if="deviceAlarmIdList.length != alarmList.length"
            @click="checkAll"
            style="color:green;"
            >全选</span
          >
          <span slot="extra" v-else @click="toggleAll" style="color:red;"
            >取消全选</span
          >
        </Cell>
      </div>
    </CellGroup>
    <CheckboxGroup
      v-model="deviceAlarmIdList"
      ref="checkboxGroup"
      icon-size="16px"
      style="height: calc(100vh - 280px);overflow-y: auto;"
    >
      <List
              style="padding: 0px 12px"
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              loading-text="拼命加载中..."
              @load="getAlarmList"
              :offset="50"
              :immediate-check="true"
      >
      <Cell v-for="(item) in alarmList" :key="item.id" clickable>
        <Checkbox :name="item.id">
          <p style="font-weight:600;color:#000">
            告警名称：{{ item.eventName }}
          </p>
          <p style="color:#555;font-size:13px;">发生时间：{{ item.time }}</p>
          <p style="color:#555;font-size:13px;margin-top:0px;">
            附加数据：{{ getParams(item) }}
          </p>
        </Checkbox>
      </Cell>
      </List>
    </CheckboxGroup>
    <Form
      @submit="submit"
      style="bottom:-250px;position:fixed;width: 95% ; margin: 250px 8px;"
    >
      <Field
        v-model="handleMethodName"
        label="处理方式"
        required
        readonly
        clearable
        @click="selectShow = true"
        placeholder="请选择处理结果"
        right-icon="arrow-down"
        :rule="[{ required: true, message: '请选择处理结果' }]"
      />
      <div>
        <Field
          v-model="handleRemark"
          type="textarea"
          clearable
          placeholder="请输入处理意见（如需）"
        />
      </div>
      <div
        style="display:flex;justify-content : space-between;width:85%;margin:auto;"
      >
        <UploadImage
          :imageList="imageList"
          style="margin-top:5px;margin-left:-15px"
          type="AlarmImage"
          @imageChange="changeImageList"
          :count="9"
          edit
        />
      </div>
      <pf code="DEVICE_HANDLE_ALARM">
        <Button
          type="info"
          block
          style="width: 95% ; margin: 10px auto;"
          native-type="submit"
          >确认提交</Button
        >
      </pf>
      <SelectDict
        dictKey="DEVICE_ALARM_HANDLE_METHOD"
        :show="selectShow"
        @cancel="selectShow = false"
        @ok="onMethodOk"
      />
    </Form>
  </div>
</template>

<script>
import {
  Button,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Dialog,
  Field,
  Form,
  List
} from "vant";
import SelectDict from "@/components/SelectPopup/SelectDict";
import UploadImage from "@/components/UploadImage";

export default {
  components: {
    Dialog,
    Cell,
    CellGroup,
    SelectDict,
    CheckboxGroup,
    Button,
    Checkbox,
    Form,
    Field,
    UploadImage,
    List
  },
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page:1,
      deviceId: this.$route.params.id,
      deviceAlarmIdList: [],
      handleMethod: [],
      handleMethodName: null,
      handleRemark: null,
      imageList: [],
      selectShow: false,
      alarmList: [],
    };
  },
  computed: {},
  created() {},
  mounted() {
      if (this.deviceId==undefined||this.deviceId=='undefined') {
          Dialog.alert({
              message: "未知异常，请联系管理员",
          }).then(() => {
              this.$router.history.go(-1);
          });
      }else {
          // this.getAlarmList();
      }
  },
  methods: {
    onCancel() {
      this.selectShow = false;
    },
    changeImageList(imageList) {
      this.imageList = imageList;
    },

    submit() {
      if (this.deviceId == undefined ||this.deviceId=='undefined') {
        this.$toast.fail(`设备id为空`);
      } else if (
        !Array.isArray(this.deviceAlarmIdList)||
          (Array.isArray(this.deviceAlarmIdList) &&
        this.deviceAlarmIdList.length === 0)
      ) {
        this.$toast.fail(`请选择告警`);
      } else if (
        this.handleMethod == '' ||
        this.handleMethod == 'null' ||
        this.handleMethod == 'undefined' ||
        this.handleMethod == undefined ||
        this.handleMethod == null
      ) {
        this.$toast.fail(`请选择处理方式`);
      } else {
        this.$toast.loading("正在处理中...");
        this.$http.tokiot.device
          .handleAlarm({
            deviceAlarmIdList: this.deviceAlarmIdList,
            handleMethod: this.handleMethod,
            handleRemark: this.handleRemark || "",
            deviceId: this.deviceId,
            handleImageList: this.imageList,
            allAlarm:this.deviceAlarmIdList.length == this.alarmList.length
          })
          .then((res) => {
            if (res) {
              const active = 2;
              this.$toast.success("处理成功");
              setTimeout(() => {
                  this.$router.go(-1)
                // this.$router.push({
                //   path: `/`,
                //   query: {
                //     active: active,
                //   },
                // });
              }, 500);
            } else {
              this.$toast.fail(res.message);
            }
          });
      }
    },
    onMethodOk(data) {
      this.handleMethodName = data.codeName;
      this.handleMethod = data.code;
      this.selectShow = false;
    },
    checkAll() {
      this.$refs.checkboxGroup.toggleAll(true);
    },
    toggleAll() {
      this.$refs.checkboxGroup.toggleAll();
    },
    getAlarmList() {
      this.$http.tokiot.enterprise.alarm
        .list({
          deviceId: this.deviceId,
          state: "UN_HANDLE",
            size: 20,
            page: this.page,
        })
        .then((res) => {
          if (res) {

            this.alarmList.push(...res.rows);
            this.page = res.pageNumber +1 ;
            this.loading = false;
            if (this.alarmList.length >= res.total) {
                this.finished = true;
            }
            if (this.alarmList.length == 0) {
                Dialog.alert({
                    message: "无警情可处理！",
                }).then(() => {
                    this.$router.history.go(-1);
                });
            }
          }
        });
    },
    getParams(item) {
      const { params } = item;
      let result = "";
      if (params) {
        JSON.parse(params).map((item) => {
          result += item.name + " （" + item.value + "）\r\n";
        });
      }
      return result;
    },
  },
  watch: {},
};
</script>

<style scoped></style>
